module.exports = __webpack_public_path__ + "img/bkl3.22baadf0.jpg";